import api from './api';

const customerService = {
  // Obtener todos los clientes
  async getAll(params = {}) {
    try {
      const response = await api.get('/customers', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener clientes:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener clientes'
      };
    }
  },

  // Obtener cliente por ID
  async getById(id) {
    try {
      const response = await api.get(`/customers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener cliente:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener cliente'
      };
    }
  },

  // Crear cliente
  async create(customerData) {
    try {
      const response = await api.post('/customers', customerData);
      return response.data;
    } catch (error) {
      console.error('Error al crear cliente:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear cliente'
      };
    }
  },

  // Actualizar cliente
  async update(id, customerData) {
    try {
      const response = await api.put(`/customers/${id}`, customerData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar cliente:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar cliente'
      };
    }
  },

  // Desactivar cliente
  async delete(id) {
    try {
      const response = await api.delete(`/customers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al desactivar cliente:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al desactivar cliente'
      };
    }
  },

  // Activar cliente
  async activate(id) {
    try {
      const response = await api.patch(`/customers/${id}/activate`);
      return response.data;
    } catch (error) {
      console.error('Error al activar cliente:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al activar cliente'
      };
    }
  },

  // Obtener estadísticas de clientes
  async getStats() {
    try {
      const response = await api.get('/customers/stats');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener estadísticas'
      };
    }
  }
};

export default customerService;

